import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconExtent = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	viewBox: "0 0 5.292 5.292",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeMiterlimit: 1.5,
		strokeWidth: 1.008,
		clipRule: "evenodd",
		children: [
			/* @__PURE__ */ _jsx("path", {
				strokeLinejoin: "miter",
				d: "m96.065 37.574-2.4-2.4-2.4 2.4M107.419 52.61l1.346 3.116-3.116 1.346",
				transform: "matrix(.21006 0 0 .21006 -18.592 -7.02)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M93.665 35.174v14.559l15.1 5.993",
				transform: "matrix(.21006 0 0 .21006 -18.592 -7.02)"
			}),
			/* @__PURE__ */ _jsx("path", {
				strokeLinejoin: "miter",
				d: "m107.721 42.352 3.051 1.487-1.488 3.051",
				transform: "matrix(.21006 0 0 .21006 -18.592 -7.02)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "m93.665 49.733 17.107-5.894",
				transform: "matrix(.21006 0 0 .21006 -18.592 -7.02)"
			})
		]
	})
});
export default SvgIconExtent;
